import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { default as pgActions } from './actions';

import { PaymentGatewayContext } from './context';

import LegacyPaymentGateway from './components/LegacyPaymentGateway';
import PremiumPaymentGateway from './components/PremiumPaymentGateway';

const propTypes = {};

const defaultProps = {};

const PaymentGateway = (props) => {
  const {
    pgState: { displayPaymentGateway },
    reducerDispatch: pgReducerDispatch,
  } = useContext(PaymentGatewayContext);

  const {
    freemium: { isEnabled: isFreemiumEnabled },
  } = useSelector((state) => state.properties.currentProperty);

  useEffect(() => {
    if (displayPaymentGateway) {
      clearResponseDataOnDisplay();
    }
  }, [displayPaymentGateway]);

  const clearResponseDataOnDisplay = () => {
    updateResponseData({});
  };

  const updateResponseData = (responseData, isResponseSuccess = false) => {
    pgActions.updateResponseData({
      reducerDispatch: pgReducerDispatch,
      responseData,
      isResponseSuccess,
    });
  };

  const updateDisplayPaymentGateway = ({ displayPaymentGateway, isPremiumMidfunnelPayment, displayContext = null }) => {
    pgActions.updateDisplayPaymentGateway({
      reducerDispatch: pgReducerDispatch,
      displayPaymentGateway,
      isPremiumMidfunnelPayment,
    });

    if (displayContext !== null) {
      pgActions.updateDisplayContext({
        reducerDispatch: pgReducerDispatch,
        displayContext,
      });
    }
  };

  const handleFreemiumResponse = (response) => {
    updateResponseData(response, true);
  };

  // non-freemium enabled listings include room for rent, mf, feed, and single family enterprise
  return (
    <>
      {isFreemiumEnabled ? (
        <PremiumPaymentGateway
          updateDisplayPaymentGateway={updateDisplayPaymentGateway}
          onFreemiumResponse={handleFreemiumResponse}
          {...props}
        />
      ) : (
        <LegacyPaymentGateway updateDisplayPaymentGateway={updateDisplayPaymentGateway} {...props} />
      )}
    </>
  );
};

PaymentGateway.propTypes = propTypes;
PaymentGateway.defaultProps = defaultProps;

export default PaymentGateway;
